import { Component, OnInit, TemplateRef } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToasterService } from '../services/toaster.service';
import { environment } from '../../environments/environment';
import { launchOfferData } from './launch-offer-data-modal';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

import { esLocale } from 'ngx-bootstrap/locale';

@Component({
  selector: 'app-launch-offer',
  templateUrl: './launch-offer.component.html',
  styleUrls: ['./launch-offer.component.css'],
  providers: [ToasterService]
})
export class LaunchOfferComponent implements OnInit {
  startDate = new Date(1990, 0, 1);
  activeTab: string = 'details';
  launch: any = {};
  modalRef: BsModalRef;
  loading: any;
  launchOffer: any = {};
  data: any = {};
  cityStateList: any;
  cityList: any;
  stateList: any;
  invalidPincode: boolean;
  error: any;
  pinCodeValue: any;
  value: any;
  ageDifference: number;
  shouldBe18: any;
  DOBrequired: any;
  claimIntimateSuccess: boolean = false;
  claimIntimateFailure: boolean = false;
  mobileNumber: string;
  email: string;
  firstName: string;
  maxDateValue: Date;
  dob: any;
  nomineeDob: boolean;
  nomineeDOBrequired: boolean;
  city: any;
  occupationListMap: { 'key': string; 'value': {}; };
  listOfOccupation: any[];
  enrollmentDetails: boolean;
  nomineeList: any;
  f: launchOfferData = new launchOfferData();
  count: number = 0;
  private onDestroy$: Subject<void> = new Subject<void>();
  public environment = environment;

  constructor(public serviceURLService: serviceURLService, private modalService: BsModalService, public toasterService: ToasterService) {
    this.maxDateValue = new Date();
   }
  ngOnInit() {
    this.getNomineeList();
    this.getAutopopulatedData();
    this.getOccupationList();
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-lg modal-dialog-centered', ignoreBackdropClick: false });
  }

  getAutopopulatedData(){
    setTimeout(() => {
      this.f.firstName = localStorage.getItem("name").split(" ")[0];
      this.f.lastName = localStorage.getItem("name").split(" ")[1];
      console.log(this.f.lastName);
      this.f.mobileNumber = localStorage.getItem("mobileNumber");
      this.f.email = localStorage.getItem("email")
    }, 500);
    this.loading = true;
    let userId = localStorage.getItem('userID');
    console.log(userId);
    this.serviceURLService.getLaunchOfferData(userId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      // console.log("successData",successData)
      
      if(successData.message == "isTrue"){
        this.enrollmentDetails = false;
        this.claimIntimateFailure = true;
        this.loading = false;
      }else{
        this.enrollmentDetails = true;
        this.claimIntimateFailure = false;
        this.loading = false;
      }
   
    }, errorData => {
      console.log("Oops..!! No Launch offer data found");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

  checkEven(val){
    return (val%2 == 0);
  }

  getSameDetailsData() {
    this.count++;
    console.log(this.count);
    if(this.checkEven(this.count)) {
      // document.getElementById('insured').onreset;
      this.f.relation = '';
      this.f.insuredTitle = '';
      this.f.insuredFirstName = '';
      this.f.insuredLastName = '';
      this.f.insuredDob = '';
    } else {
      this.f.relation = "SELF";
      this.f.insuredTitle = this.f.title;
      this.f.insuredFirstName = this.f.firstName;
      this.f.insuredLastName = this.f.lastName;
      this.f.insuredDob = this.f.dob;
    }
  }

  getCityStateList(pinCode) {
    this.pinCodeValue = pinCode;
    this.loading = true;
    this.data = {
      "pincode": JSON.stringify(this.pinCodeValue)
    }
    // console.group(this.data);
    this.serviceURLService.getCityStateList(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.cityStateList = successData.data;
      this.cityList = successData.data.cityList;
      this.stateList = successData.data.state;

      this.f.city = this.cityList[0];
      this.f.state = this.stateList;
      this.loading = false;

      if (this.cityList.length == 0) {
        var proceedButton = <HTMLInputElement>document.getElementById("proceedPayment");
        proceedButton.disabled = true;
        this.invalidPincode = true;
      }
      else {
        this.invalidPincode = false;
      }
    }, errorData => {
      console.log("Oops..!! city/state list not found");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar) ) {
      event.preventDefault();
    }
  }

  // for tab change functionality
  details(activeTab) {
    this.activeTab = activeTab;
  }

  insured(activeTab) {
    this.activeTab = activeTab;
  }

  submitLaunchOffer() {
    // console.log("launch data ",this.launch);
    this.loading = true;
    
    this.launchOffer = {
      "mobileNumber": this.f.mobileNumber,
      "email": this.f.email,
      "title": this.f.title,
      "firstName": this.f.firstName,
      "lastName": this.f.lastName,
      "dOb": this.f.dob,
      "panNumber": this.f.panNumber,
      "pinCode": this.f.pinCode,
      "city": this.f.city,
      "state": this.f.state,
      "address1": this.f.address1,
      "address2": this.f.address2,
      "idRelation": this.f.relation,
      "idTitle":this.f.insuredTitle,
      "idFName": this.f.insuredFirstName,
      "idLastName":this.f.insuredLastName,
      "idDOB": this.f.insuredDob, 
      "occupation": this.f.occupation,
     
      "nomineeFirstName": this.f.nomineeName,
      "nomineeLastRelation": this.f.nomineeRelation,
      
    }
     

    let userId = localStorage.getItem('userID');
    this.serviceURLService.launchOffer(this.launchOffer, userId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      // this.toasterService.showErrorToaster(successData.message);
      this.claimIntimateSuccess = true;
      this.claimIntimateFailure = false;
      this.loading = false;
      this.modalRef.hide();
    }, errorData => {
      this.loading = false;
      this.error = errorData.error.message;
      this.claimIntimateSuccess = false;
      this.claimIntimateFailure =true;
      this.toasterService.showErrorToaster(this.error);
    }
    )
  }

  checkValue(){
    // console.log(this.launch);
    
    if( this.launch.dOb ){
      this.DOBrequired= true;
    }
  }

  getNomineeList() {
    this.serviceURLService.getNomineeList().pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
      this.nomineeList = successData.data.nomineeList;
    }, errorData => {
      console.log("Oops..!! nominee list not found");
      if(errorData.error.status === 403){
        this.error = errorData.error.message;
      }
    })
  }

  getOccupationList() {
    this.serviceURLService.getOccupationList().pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
     // this.occupationList = successData.data.occupation;
      // console.log("occupation ",successData)
      var occupationList = Object.values(successData.data.occupation)
      
      let newOccupationList=[];

      for (let i=0;i<(occupationList).length;i++){
        this.occupationListMap = {
          'key' : Object.keys(successData.data.occupation)[i],
          'value' : Object.values(successData.data.occupation)[i]
        }
        newOccupationList.push(this.occupationListMap)
      }

      this.listOfOccupation = newOccupationList;
    }, errorData => {
      console.log("Oops..!! nominee list not found");
      if(errorData.error.status === 403){
        this.error = errorData.error.message;
      }
    })
  }

  checkDOBvalue(){
    if( this.f.dob){
      this.DOBrequired= false;
    }else{
      this.DOBrequired= true;
    }
  }
  calculateAge() { 
    this.DOBrequired = false;
    var regesterDate = new Date(this.f.dob);
    var ageDifMs = Date.now() - regesterDate.getTime();
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    this.ageDifference = Math.abs(ageDate.getUTCFullYear() - 1970);
      if(this.ageDifference < 18){
        var proceedButton = <HTMLInputElement>document.getElementById("proceedPayment");
        proceedButton.disabled = true;
        this.shouldBe18= true;
      }else{
        var proceedButton = <HTMLInputElement>document.getElementById("proceedPayment");
        this.shouldBe18= false;
      }
    
  }

  checkNomineeDOBvalue(){
    if( this.launch.nomineeDOB){
      this.nomineeDOBrequired= false;
    }else{
      this.nomineeDOBrequired= true;
    }
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }

}
